module.exports = __webpack_public_path__ + "img/email.07a1b1d1.png";